/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const redboothRequest = /* GraphQL */ `
  query RedboothRequest($request: String) {
    redboothRequest(request: $request)
  }
`;
export const getOrganization = /* GraphQL */ `
  query GetOrganization($id: ID!) {
    getOrganization(id: $id) {
      id
      name
      shortName
      users {
        items {
          id
          firstName
          lastName
          username
          email
          orgID
          cognitoID
          createdAt
          updatedAt
        }
        nextToken
      }
      websites {
        items {
          id
          orgID
          domain
          createdAt
          updatedAt
        }
        nextToken
      }
      clientLeads
      createdAt
      updatedAt
    }
  }
`;
export const listOrganizations = /* GraphQL */ `
  query ListOrganizations(
    $filter: ModelOrganizationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        shortName
        users {
          nextToken
        }
        websites {
          nextToken
        }
        clientLeads
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      id
      firstName
      lastName
      username
      email
      orgID
      organization {
        id
        name
        shortName
        users {
          nextToken
        }
        websites {
          nextToken
        }
        clientLeads
        createdAt
        updatedAt
      }
      cognitoID
      requests {
        items {
          id
          status
          userID
          ticketID
          redboothID
          title
          websiteID
          urgent
          dueDate
          orgID
          createdAt
          updatedAt
        }
        nextToken
      }
      createdAt
      updatedAt
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        firstName
        lastName
        username
        email
        orgID
        organization {
          id
          name
          shortName
          clientLeads
          createdAt
          updatedAt
        }
        cognitoID
        requests {
          nextToken
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getWebsite = /* GraphQL */ `
  query GetWebsite($id: ID!) {
    getWebsite(id: $id) {
      id
      orgID
      organization {
        id
        name
        shortName
        users {
          nextToken
        }
        websites {
          nextToken
        }
        clientLeads
        createdAt
        updatedAt
      }
      domain
      createdAt
      updatedAt
    }
  }
`;
export const listWebsites = /* GraphQL */ `
  query ListWebsites(
    $filter: ModelWebsiteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listWebsites(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        orgID
        organization {
          id
          name
          shortName
          clientLeads
          createdAt
          updatedAt
        }
        domain
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getRequest = /* GraphQL */ `
  query GetRequest($id: ID!) {
    getRequest(id: $id) {
      id
      status
      userID
      user {
        id
        firstName
        lastName
        username
        email
        orgID
        organization {
          id
          name
          shortName
          clientLeads
          createdAt
          updatedAt
        }
        cognitoID
        requests {
          nextToken
        }
        createdAt
        updatedAt
      }
      ticketID
      redboothID
      title
      websiteID
      website {
        id
        orgID
        organization {
          id
          name
          shortName
          clientLeads
          createdAt
          updatedAt
        }
        domain
        createdAt
        updatedAt
      }
      urgent
      dueDate
      files {
        items {
          id
          requestID
          name
          s3Key
          createdAt
          updatedAt
        }
        nextToken
      }
      pages {
        items {
          id
          requestID
          url
          description
          createdAt
          updatedAt
        }
        nextToken
      }
      orgID
      organization {
        id
        name
        shortName
        users {
          nextToken
        }
        websites {
          nextToken
        }
        clientLeads
        createdAt
        updatedAt
      }
      createdAt
      updatedAt
    }
  }
`;
export const listRequests = /* GraphQL */ `
  query ListRequests(
    $filter: ModelRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listRequests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        status
        userID
        user {
          id
          firstName
          lastName
          username
          email
          orgID
          cognitoID
          createdAt
          updatedAt
        }
        ticketID
        redboothID
        title
        websiteID
        website {
          id
          orgID
          domain
          createdAt
          updatedAt
        }
        urgent
        dueDate
        files {
          nextToken
        }
        pages {
          nextToken
        }
        orgID
        organization {
          id
          name
          shortName
          clientLeads
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getFile = /* GraphQL */ `
  query GetFile($id: ID!) {
    getFile(id: $id) {
      id
      requestID
      name
      s3Key
      createdAt
      updatedAt
    }
  }
`;
export const listFiles = /* GraphQL */ `
  query ListFiles(
    $filter: ModelFileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listFiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        requestID
        name
        s3Key
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getPage = /* GraphQL */ `
  query GetPage($id: ID!) {
    getPage(id: $id) {
      id
      requestID
      url
      description
      createdAt
      updatedAt
    }
  }
`;
export const listPages = /* GraphQL */ `
  query ListPages(
    $filter: ModelPageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        requestID
        url
        description
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const requestByStatus = /* GraphQL */ `
  query RequestByStatus(
    $status: String
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    requestByStatus(
      status: $status
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        userID
        user {
          id
          firstName
          lastName
          username
          email
          orgID
          cognitoID
          createdAt
          updatedAt
        }
        ticketID
        redboothID
        title
        websiteID
        website {
          id
          orgID
          domain
          createdAt
          updatedAt
        }
        urgent
        dueDate
        files {
          nextToken
        }
        pages {
          nextToken
        }
        orgID
        organization {
          id
          name
          shortName
          clientLeads
          createdAt
          updatedAt
        }
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
